import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Cait = makeShortcode("Cait");
const NoCait = makeShortcode("NoCait");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "update-21222"
    }}>{`Update 2/12/22`}</h2>
    <p>{`I've updated these notes with quadraacep's changes to the route (Force Shield skip, early H'aanit) along with some menu order optimizations and whatnot. I only looked at the Cait route, although I think all the changes apply to both routes. `}</p>
    <p>{`I also recommend using `}<a parentName="p" {...{
        "href": "https://docs.google.com/document/d/1lPwOckVpeMikfvulsHJl42WL2OlD3z-pN66PUrbpYJY/edit#"
      }}>{`quadraaceps's Notes`}</a>{`, especially if you want to make your own changes. He's been running more actively and his notes are likely to be more up to date in the future. To my knowledge, he doesn't have notes for the Cait route so these are still of use.`}</p>
    <SEO title="Octopath Traveler Galdera Notes" mdxType="SEO" />
    <h2 {...{
      "id": "galdera-notes"
    }}>{`GALDERA NOTES`}</h2>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Wolf’s Bow`}</strong>{`.`}</p>
    <Cait mdxType="Cait">Run/Break from all encounters.</Cait>
    <NoCait mdxType="NoCait">Kill first Pirate with Defend, Bow, Tradewinds x3</NoCait>
    <p>{`Skip the Thunder S, if below 250HP Heal.`}</p>
    <h4 {...{
      "id": "mikk-and-makk"
    }}>{`Mikk and Makk`}</h4>
    <p>{`T1-3: Tradewinds Mikk`}<br parentName="p"></br>{`
`}{`T4: Tradewinds x4 Mikk (kill)`}<br parentName="p"></br>{`
`}{`T5-6: Tradewinds / Grape`}<br parentName="p"></br>{`
`}{`T7: Tradewinds x4`}<br parentName="p"></br>{`
`}{`T8: Bow`}<br parentName="p"></br>{`
`}{`T9: Defend`}<br parentName="p"></br>{`
`}{`T10: Bow`}<br parentName="p"></br>{`
`}{`T11: Tradewinds x4`}</p>
    <p>{`Run to `}<strong parentName="p">{`Atlasdam`}</strong>{`, completing the Kit sidequest immediately.`}</p>
    <Cait mdxType="Cait">
      <p>{`Tag `}<strong parentName="p">{`Atlasdam`}</strong>{`, head to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`.`}</p>
      <p>{`Find a Cait along the way and kill it with `}<strong parentName="p">{`Ice M`}</strong>{`.`}</p>
      <p>{`To deal with the Scholar shrine encounter, you can either run OR teach `}<strong parentName="p">{`Hired Help`}</strong>{` before the encounter and do HHDx2, Bow, then Bow x2.`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "jobs"
        }}>{`Jobs`}</h5>
        <p>{`Tressa: `}<strong parentName="p">{`Scholar`}</strong>{`, Lightning Bolt, Blizzard`}</p>
        <h5 {...{
          "id": "skills"
        }}>{`Skills`}</h5>
        <p>{`Tressa: Evasive Maneuvers`}</p>
      </Menu>
    </Cait>
    <NoCait mdxType="NoCait">
      <h3 {...{
        "id": "cyrus-ch1"
      }}>{`Cyrus Ch.1`}</h3>
      <p>{`Kill two battles in Subterranean Study`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "skills-1"
        }}>{`Skills`}</h5>
        <p>{`Tressa: Hired Help`}</p>
      </Menu>
      <h4 {...{
        "id": "russell"
      }}>{`Russell`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Ice M`}</li>
        <li parentName="ul">{`Cyrus: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Attack x3`}</li>
        <li parentName="ul">{`Tressa: HHD x3`}</li>
      </ul>
      <p>{`Purchase `}<strong parentName="p">{`Thunder S`}</strong>{` from guard by library. Scrutinize `}<strong parentName="p">{`Light M`}</strong>{`, head to `}<strong parentName="p">{`Whistlewood`}</strong>{`.`}</p>
      <p>{`Kill battles on the way with Hired Help Bandits (x2) if Meep in group.`}</p>
      <p>{`Kill battle in Whistlewood with Light M (If Howlers break with Thunder S then kill with Light M)`}</p>
      <p>{`After Cyrus has 130 JP do this menu.`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "jobs-1"
        }}>{`Jobs`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Donate BP`}</li>
          <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Scholar`}</strong>{`, Fire Storm, Blizzard`}</li>
        </ul>
        <h5 {...{
          "id": "skills-2"
        }}>{`Skills`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Endless Items`}</li>
          <li parentName="ul">{`Cyrus: Evasive Maneuver`}</li>
        </ul>
      </Menu>
    </NoCait>
    <p>{`Get `}<strong parentName="p">{`Scholar Shrine`}</strong>{`, tag `}<strong parentName="p">{`Noblecourt`}</strong>{`. TP to `}<strong parentName="p">{`Rippletide`}</strong>{`, tag `}<strong parentName="p">{`Cobbleston`}</strong>{` and head towards `}<strong parentName="p">{`North Stonegard Pass`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Break encounter in North Stonegard Pass with 2xBandits and flee. `}<NoCait mdxType="NoCait">{`If Cyrus first, use Firestorm + Defend > 3x Bow Bird.`}</NoCait></p>
    </blockquote>
    <p>{`Get `}<strong parentName="p">{`Warrior Shrine`}</strong>{`, tag `}<strong parentName="p">{`Stonegard`}</strong>{`, go to `}<strong parentName="p">{`Moonstruck Coast`}</strong>{`. S&Q at save, get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`, tag `}<strong parentName="p">{`Goldshore`}</strong>{`. `}<NoCait mdxType="NoCait">{`Scrutinize old man by entrance & pick `}<strong parentName="p">{`Thunder L`}</strong>{` during Alfyn Ch.2.`}</NoCait>{` Head towards `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p><strong parentName="p">{`West Grandport Coast`}</strong>{` get `}<strong parentName="p">{`$20000`}</strong>{`, and save/reload at save point. Pick `}<strong parentName="p">{`Thunder L`}</strong>{`, enter `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Adamantite Shield`}</strong>{` from first guy by entrance.`}</p>
    <p>{`Go to tavern and buy `}<strong parentName="p">{`Nourishing M`}</strong>{`, `}<strong parentName="p">{`Fortifying M`}</strong>{`, and `}<strong parentName="p">{`Magic M`}</strong>{` from the merchant in the middle. On the next screen, buy a `}<strong parentName="p">{`Pom L`}</strong>{` from the noble in red, get the `}<strong parentName="p">{`Silver-Filled Pouch`}</strong>{`, buy another `}<strong parentName="p">{`Pom L`}</strong>{` from the man in green, and all `}<strong parentName="p">{`pomegranates`}</strong>{` from the lady in red. On the next screen, get `}<strong parentName="p">{`$25000 + Artwork`}</strong>{`, and TP to `}<strong parentName="p">{`Cobbleston`}</strong>{`.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Sunshade`}</strong>{`, `}<strong parentName="p">{`Clearbrook`}</strong>{`, and enter `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch2-start"
    }}>{`Tressa Ch.2 Start`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Thunder L`}</strong>{`, `}<strong parentName="p">{`Thunder M`}</strong>{`. On screen with story purchases buy `}<strong parentName="p">{`Curious Bloom `}</strong>{`, `}<strong parentName="p">{`Shadow M`}</strong>{`, `}<strong parentName="p">{`Fire M`}</strong>{`, and `}<strong parentName="p">{`Light M`}</strong>{`. Pick `}<strong parentName="p">{`Fool's Gold Ore`}</strong>{` and after last purchase TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <p>{`Head east to the next screen. `}<NoCait mdxType="NoCait">{`You can buy 3M Stones here, you can make up the money by skipping an L Stone purchase or picking up more gold items.`}</NoCait>{` Buy `}<strong parentName="p">{`Mighty Belt`}</strong>{` and `}<strong parentName="p">{`Elemental Augmentor`}</strong>{` from the old man at the end, then TP back to `}<strong parentName="p">{`Quarrycrest`}</strong>{` and head to `}<strong parentName="p">{`Bolderfall`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <p>{`Kill`}<Cait mdxType="Cait">{`/break`}</Cait>{` encounter in Ravus Manor with Bandits / `}<Cait mdxType="Cait">{`Dagger`}</Cait><NoCait mdxType="NoCait">{`M Stone or S&Q.`}</NoCait></p>
    <h4 {...{
      "id": "heathcote"
    }}>{`Heathcote`}</h4>
    <p>{`Thunder L`}<NoCait mdxType="NoCait">{` + M Stone`}</NoCait></p>
    <p>{`Steal `}<strong parentName="p">{`Energizing Pomegranate, Nourishing Nut`}</strong>{` from lady by entrance.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You have 1 Thunder L to use on either Victor's Hollow or Cleric Shrine battle if you get them.`}</p>
    </blockquote>
    <p>{`Tag `}<strong parentName="p">{`Victor’s Hollow`}</strong>{`, Purchase `}<strong parentName="p">{`Nourishing M, Invigorating M, Magic M`}</strong>{` from the man by the entrance. Get `}<strong parentName="p">{`Hunter Shrine`}</strong>{` and `}<strong parentName="p">{`Olive L`}</strong>{`. Get `}<strong parentName="p">{`Cleric Shrine`}</strong>{`, tag `}<strong parentName="p">{`Stillsnow`}</strong>{`, and go to `}<strong parentName="p">{`Maw of the Ice Dragon`}</strong>{`. Get `}<strong parentName="p">{`$30000`}</strong>{` in the first red chest you see and `}<strong parentName="p">{`Adamantine Hat`}</strong>{` in the purple chest to the south.  TP to `}<strong parentName="p">{`Sunshade`}</strong>{`, head out to the right. Pick `}<strong parentName="p">{`Old Coin`}</strong>{` if you used lots of Bandits.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Dancer Shrine`}</strong>{`, reload at south exit, tag `}<strong parentName="p">{`Wellspring`}</strong>{`. Get `}<strong parentName="p">{`Thunder L`}</strong>{` + `}<strong parentName="p">{`$20000`}</strong>{` chest in screen before `}<strong parentName="p">{`Marsalim`}</strong>{`, reload at `}<strong parentName="p">{`Marsalim Catacombs`}</strong>{`.`}</p>
    <p>{`Enter `}<strong parentName="p">{`Marsalim`}</strong>{`, buy `}<strong parentName="p">{`ONLY Magic M`}</strong>{` from guy by entrance near shop. Go to palace, buy 2 `}<strong parentName="p">{`Pom M`}</strong>{` from left guard, purchase `}<strong parentName="p">{`Fire L, Wind L, Shadow L`}</strong>{` from right guard. Pick `}<strong parentName="p">{`Enchanted Circlet, $25,000, High House Armor`}</strong>{` in the three red chests in the room to the far right.`}</p>
    <p>{`TP to `}<strong parentName="p">{`Stonegard`}</strong>{`, go to `}<strong parentName="p">{`West Everhold Pass`}</strong>{`. Pick `}<strong parentName="p">{`Light L`}</strong>{` + `}<strong parentName="p">{`Pouch`}</strong>{`, `}<strong parentName="p">{`Save & Reload`}</strong>{`, Enter `}<strong parentName="p">{`Everhold`}</strong>{`.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Sorcerer’s Robe`}</strong>{` and `}<strong parentName="p">{`Shadow L`}</strong>{` and go back out. `}<strong parentName="p">{`Save & Reload`}</strong>{`, get `}<strong parentName="p">{`Pom M`}</strong>{`, go to `}<strong parentName="p">{`West Everhold Tunnels`}</strong>{`.`}</p>
    <p>{`Get `}<strong parentName="p">{`Pom L`}</strong>{`, reset steps. get `}<strong parentName="p">{`$35000`}</strong>{`, `}<strong parentName="p">{`Knowledge Staff`}</strong>{`, `}<strong parentName="p">{`Death Cleaver`}</strong>{`, resetting steps in between all of them.`}</p>
    <p>{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
    <NoCait mdxType="NoCait">
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "equipment"
        }}>{`Equipment`}</h5>
        <ul>
          <li parentName="ul">{`Cyrus: Optimize, Elemental Augmentor`}</li>
          <li parentName="ul">{`Therion: Optimize`}</li>
        </ul>
      </Menu>
    </NoCait>
    <Cait mdxType="Cait">
      <h3 {...{
        "id": "cyrus-ch1-1"
      }}>{`Cyrus Ch.1`}</h3>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "equipment-1"
        }}>{`Equipment`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Optimize, Elemental Augmentor`}</li>
          <li parentName="ul">{`Therion: Optimize`}</li>
        </ul>
      </Menu>
      <h4 {...{
        "id": "russell-1"
      }}>{`Russell`}</h4>
      <p>{`Shadow L + Blizzard x2`}</p>
    </Cait>
    <p>{`Run to `}<strong parentName="p">{`Flamesgrace`}</strong></p>
    <h3 {...{
      "id": "ophilia-ch1"
    }}>{`Ophilia Ch.1`}</h3>
    <h4 {...{
      "id": "guardian"
    }}>{`Guardian`}</h4>
    <Cait mdxType="Cait">
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Blizzard`}</li>
        <li parentName="ul">{`Two Others: Attack x2`}</li>
        <li parentName="ul">{`Last one: Pom S Tressa`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Blizzard x4`}</li>
        <li parentName="ul">{`Anyone else: Stone M`}</li>
      </ul>
    </Cait>
    <NoCait mdxType="NoCait">
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Blizzard`}</li>
        <li parentName="ul">{`Therion & Ophilia: Attack x2`}</li>
        <li parentName="ul">{`Tressa: Pom S Cyrus`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Blizzard x4`}</li>
        <li parentName="ul">{`Anyone else: Stone M`}</li>
      </ul>
    </NoCait>
    <p>{`TP `}<strong parentName="p">{`Clearbrook`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch1"
    }}>{`Alfyn Ch.1`}</h3>
    <Menu mdxType="Menu">
      <p>{`You can do this after Viper to see if you got a Herb of Healing drop.`}</p>
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 Herb of Healing`}</li>
        <li parentName="ul">{`11 Injurious Seed`}</li>
        <li parentName="ul">{`2 Essence of Grape`}</li>
      </ul>
    </Menu>
    <p>{`Start Alfyn 1, swap `}<strong parentName="p">{`Therion`}</strong>{` for Alfyn.`}</p>
    <h4 {...{
      "id": "blotted-viper"
    }}>{`Blotted Viper`}</h4>
    <ul>
      <li parentName="ul"><Cait mdxType="Cait">Tressa</Cait><NoCait mdxType="NoCait">Cyrus</NoCait>: Blizzard x2</li>
      <li parentName="ul">{`Others: Shadow L + M Stone`}</li>
    </ul>
    <p>{`If delaying shop, do it before resting at Alfyn's house.`}</p>
    <p><strong parentName="p">{`After last cutscene, BUY ESSENCE OF POMEGRANITE FROM MERYL.`}</strong></p>
    <p>{`TP to `}<strong parentName="p">{`Sunshade`}</strong>{`, go to `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <p>{`If you get a battle, kill with Blizzard x2 or an L/M Stone.`}</p>
    <h3 {...{
      "id": "ophilia-ch2"
    }}>{`Ophilia Ch.2`}</h3>
    <p>{`Scrutinize NPC on bridge for New Weapons for Sale (30%).`}</p>
    <Cait mdxType="Cait">
      <p>{`Go to Tavern and swap `}<strong parentName="p">{`Cyrus`}</strong>{` for `}<strong parentName="p">{`Therion`}</strong></p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "equipment-in-tavern"
        }}>{`Equipment (In Tavern)`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Unequip`}</li>
          <li parentName="ul">{`Alfyn: Death Cleaver`}</li>
          <li parentName="ul">{`Ophilia: Optimize, Elemental Augmentor`}</li>
        </ul>
        <h5 {...{
          "id": "formation"
        }}>{`Formation`}</h5>
        <ul>
          <li parentName="ul">{`Tressa > Ophilia`}</li>
        </ul>
        <h5 {...{
          "id": "items"
        }}>{`Items`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Nourishing M`}</li>
          <li parentName="ul">{`Ophilia: Nourishing S, Nourishing M, Invigorating M x2, Magic M x3`}</li>
          <li parentName="ul">{`Therion: Fortifying M`}</li>
        </ul>
        <h5 {...{
          "id": "jobs-2"
        }}>{`Jobs`}</h5>
        <ul>
          <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Scholar`}</strong>{`, Blizzard`}</li>
          <li parentName="ul">{`Alfyn: Amputation, `}<strong parentName="li">{`Warrior`}</strong></li>
          <li parentName="ul">{`Therion: Armor Corrosive`}</li>
          <li parentName="ul">{`Tressa: Donate BP, `}<strong parentName="li">{`Hunter`}</strong></li>
        </ul>
      </Menu>
    </Cait>
    <NoCait mdxType="NoCait">
      <p>{`Go to Tavern.`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "equipment-2"
        }}>{`Equipment`}</h5>
        <ul>
          <li parentName="ul">{`Cyrus: Unequip All`}</li>
          <li parentName="ul">{`Alfyn: Death Cleaver`}</li>
          <li parentName="ul">{`Ophilia: Optimize, Elemental Augmentor`}</li>
        </ul>
        <h5 {...{
          "id": "change-party"
        }}>{`Change Party`}</h5>
        <p>{`Therion > Cyrus`}</p>
      </Menu>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "items-1"
        }}>{`Items`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Nourishing M`}</li>
          <li parentName="ul">{`Ophilia: Nourishing S, Nourishing M, Invigorating M x2, Magic M x3`}</li>
          <li parentName="ul">{`Therion: Fortifying M`}</li>
        </ul>
        <h5 {...{
          "id": "healing"
        }}>{`Healing`}</h5>
        <p>{`Heal Wounds`}</p>
        <h5 {...{
          "id": "jobs-3"
        }}>{`Jobs`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Donate BP, `}<strong parentName="li">{`Scholar`}</strong>{`, first 2 skills, `}<strong parentName="li">{`Hunter`}</strong></li>
          <li parentName="ul">{`Therion: Armor Corrosive`}</li>
          <li parentName="ul">{`Alfyn: Amputation, `}<strong parentName="li">{`Warrior`}</strong></li>
          <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Scholar`}</strong>{`, Blizzard`}</li>
        </ul>
        <h5 {...{
          "id": "formation-1"
        }}>{`Formation`}</h5>
        <ul>
          <li parentName="ul">{`Tressa > Ophilia`}</li>
          <li parentName="ul">{`Therion > Alfyn`}</li>
        </ul>
        <h5 {...{
          "id": "skills-3"
        }}>{`Skills`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Evasive Maneuvers`}</li>
        </ul>
      </Menu>
    </NoCait>
    <p>{`Get `}<strong parentName="p">{`Heavy Coin Pouch`}</strong>{` in Deryl’s house. `}<NoCait mdxType="NoCait">{`Pick $3500. `}</NoCait>{`Kill encounter with Blizzard x2. Kill encounter in Murkwood with Thunder/Shadow L. If no tree Blizzard x3 kills too.`}</p>
    <h4 {...{
      "id": "hrodvitnir"
    }}>{`Hrodvitnir`}</h4>
    <h5 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Blizzard`}</li>
      <li parentName="ul">{`Alfyn: Concoct Injurious Seed + Addlewort`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
      <li parentName="ul">{`Tressa: Attack`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Blizzard x3`}</li>
      <li parentName="ul">{`Alfyn: Amputation x3`}</li>
      <li parentName="ul">{`Tressa: HHVx3`}</li>
    </ul>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-shop"
      }}>{`Weapon Shop`}</h5>
      <ul>
        <li parentName="ul">{`5 Empowering Bracelet`}</li>
        <li parentName="ul">{`Sell Gold Items`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-3"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`-Adamantite Shield`}</strong>{`, Empowering Bracelet`}</li>
        <li parentName="ul">{`Alfyn: Empowering Bracelet x2`}</li>
        <li parentName="ul">{`Therion: Empowering Bracelet`}</li>
        <li parentName="ul">{`Tressa: Optimize, Empowering Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "healing-1"
      }}>{`Healing`}</h5>
      <p>{`Heal Wounds`}</p>
      <h5 {...{
        "id": "jobs-4"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Lightning Blast`}</li>
        <li parentName="ul">{`Alfyn: Spearhead + Thousand Spears, `}<strong parentName="li">{`Merchant`}</strong>{`, Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Therion: Shackle Foe, `}<strong parentName="li">{`Dancer`}</strong>{`, Peacock Strut + Mole Dance`}</li>
        <li parentName="ul">{`Tressa: Leghold Trap + Arrowstorm`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Evasive Maneuvers`}</li>
        <li parentName="ul">{`Alfyn: Endless Items, Cover`}</li>
        <li parentName="ul">{`Tressa: `}<Cait mdxType="Cait">{`Endless Items, `}</Cait>{`Heightened Senses`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ophilia-ch3"
    }}>{`Ophilia Ch.3`}</h3>
    <p>{`Pick `}<strong parentName="p">{`$4500`}</strong>{`.`}</p>
    <p>{`After guiding NPC to cathedral, TP `}<strong parentName="p">{`Stillsnow`}</strong>{` and head to `}<strong parentName="p">{`Northreach`}</strong>{`.`}</p>
    <p>{`Break Lizards with Bandits x2 and kill with a L Stone or Peacock + Lightning Blast x4`}<br parentName="p"></br>{`
`}{`M Stone + Lightning Blast x3 or Peacock + Lightning Blast x2 kills as well.`}</p>
    <h4 {...{
      "id": "northreach"
    }}>{`Northreach`}</h4>
    <p>{`Purchase `}<strong parentName="p">{`Empowering Necklace`}</strong>{` from man by the entrance. Purchase `}<strong parentName="p">{`Resistant L, Fool's Gold Ore, Curious Antique`}</strong>{` from man standing to the left of the items shop. Purchase `}<strong parentName="p">{`Magic L`}</strong>{` from Angela. Pick `}<strong parentName="p">{`Master's Longbow`}</strong>{` in Tavern.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-4"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Empowering Necklace`}</li>
        <li parentName="ul">{`Tressa: Empowering Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "inventory"
      }}>{`Inventory`}</h5>
      <ul>
        <li parentName="ul">{`Healing Grape Ophilia & Tressa`}</li>
        <li parentName="ul">{`Ophilia: Magic L`}</li>
        <li parentName="ul">{`Tressa: Resistant L`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <p>{`Can pick `}<strong parentName="p">{`Thunder M`}</strong>{` by the tavern. Head to Seaside Grotto.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Mash cutscene in front of the cave instead of holding to skip, you can immediately start moving as the screen fades in.`}</p>
    </blockquote>
    <p>{`Enter Grotto, kill encounter.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you had to restore reputation in Saintsbridge, pick `}<strong parentName="p">{`Silver-Filled Pouch`}</strong>{` before boss.`}</p>
    </blockquote>
    <h4 {...{
      "id": "mystery-man--shady-figure"
    }}>{`Mystery Man & Shady Figure`}</h4>
    <h5 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Pom M Alfyn`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
      <li parentName="ul">{`Therion: 2x Armor Corrosive MM`}</li>
      <li parentName="ul">{`Tressa: Attack MM`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-4"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: HHBx4`}</li>
      <li parentName="ul">{`Ophilia: Pom M Alfyn`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive SF`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHMx4`}</li>
      <li parentName="ul">{`Alfyn: HHVx4`}</li>
      <li parentName="ul">{`Ophilia: Lightning Blast x4`}</li>
      <li parentName="ul">{`Therion: Peacock/Soulstone M (only needed if Magic L not used, even then its a range)`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch2-start"
    }}>{`Therion Ch.2 Start`}</h3>
    <p>{`Trigger first cutscene & the cutscene inside the bar for Therion 2. Guide `}<strong parentName="p">{`Aspiring Actor`}</strong>{`, on the stairs near the cemetery. Purchase `}<strong parentName="p">{`Pom Mx2`}</strong>{` from man in the cemetery.`}</p>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <p>{`Head towards Duskbarrow. You can choose to S&Q, or YOLO. If you get battle better to kill it. Tree has just under 10k HP. I recommend taking an extra battle at some point before Dreisang for XP/JP.`}</p>
    <p>{`Enter `}<strong parentName="p">{`Duskbarrow`}</strong>{`. Buy `}<strong parentName="p">{`Curious Antique`}</strong>{` by shop, pick `}<strong parentName="p">{`$30000`}</strong>{` in center of town and `}<strong parentName="p">{`Curious Antique`}</strong>{` in top-left corner.`}</p>
    <p>{`TP back to `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <p><strong parentName="p">{`Inquire Thieving Tip & Tricks`}</strong>{` (merchant by entrance), trigger first steal cutscene and then finish sidequest: In Search of Father (I) (Talk to Kit)`}</p>
    <p>{`Pick `}<strong parentName="p">{`Cat's Eye`}</strong>{`, kill Plains Drakes on the way to `}<strong parentName="p">{`Wispermill`}</strong>{`. Arrowstorm to break, Lightning Blast x4 + Peacock kills.`}</p>
    <h3 {...{
      "id": "ophilia-ch4"
    }}>{`Ophilia Ch.4`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{` near the shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`11 Healing Grape M`}</li>
        <li parentName="ul">{`21 Inspiriting Plum`}</li>
        <li parentName="ul">{`11 `}<strong parentName="li">{`Herbs of Clamor`}</strong></li>
      </ul>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Sell all gold items.`}</li>
      </ul>
    </Menu>
    <p>{`Pick `}<strong parentName="p">{`Giant's Club`}</strong>{` and `}<strong parentName="p">{`Adamantite Hat`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-5"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Optimize`}</li>
        <li parentName="ul">{`Tressa: Enchanted Circlet`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-optional"
      }}>{`Jobs (Optional)`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Warrior`}</strong></li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Luminescence`}</li>
        <li parentName="ul">{`Alfyn: 2 Apothecary skills`}</li>
        <li parentName="ul">{`Tressa: 1 Merchant Skill`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Hale & Hearty`}</li>
        <li parentName="ul">{`Tressa: Grow on Trees`}</li>
      </ul>
    </Menu>
    <p>{`Kill encounter with Light L x2 or 1 Light L + any L, and Lightning Blast as needed (will need x3 + Peacock for mushrooms).`}</p>
    <p><strong parentName="p">{`After battle, watch Tressa's EXP to next level.`}</strong><br parentName="p"></br>{`
`}{`You get `}<strong parentName="p">{`546`}</strong>{` from Cultists, if you're not gonna level up try to heal her during Cultists fight.`}</p>
    <p>{`Pick `}<strong parentName="p">{`30000$`}</strong>{`, save at Mattias (optional)`}</p>
    <h4 {...{
      "id": "cultists"
    }}>{`Cultists`}</h4>
    <h5 {...{
      "id": "turn-1-5"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Holy Light`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
      <li parentName="ul">{`Therion: Peacock Ophilia`}</li>
      <li parentName="ul">{`Tressa: Donate BP Ophilia`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: HHM x3 (Bandits to fix range)`}</li>
      <li parentName="ul">{`Ophilia: Lightning Blast x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`At level 21 Tressa double tap is a very unlikely range to kill.`}</p>
    </blockquote>
    <h4 {...{
      "id": "mattias"
    }}>{`Mattias`}</h4>
    <h5 {...{
      "id": "turn-1-6"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Alfyn: Injurious Seed + Addlewort`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
      <li parentName="ul">{`Tressa: Pom L Alfyn`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-6"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Blizzard`}</li>
      <li parentName="ul">{`Alfyn: HHVx4`}</li>
      <li parentName="ul">{`Therion: Pom M Tressa`}</li>
      <li parentName="ul">{`Tressa: HHVx3 (DO NOT x4, it makes Mattias a range)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Lighting Blast x4`}</li>
      <li parentName="ul">{`Alfyn: HHVx3`}</li>
      <li parentName="ul">{`Tressa: HHVx3`}</li>
    </ul>
    <h3 {...{
      "id": "dreisang"
    }}>{`Dreisang`}</h3>
    <p>{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Flying Helm`}</strong>{` from `}<strong parentName="p">{`Capable Culinaran`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`House Landar Records`}</strong>{` from bottom-left guy downstairs. Go to bottom-left side part of town to guide Whispermill guy.`}</p>
    <p>{`TP `}<strong parentName="p">{`Wispermill`}</strong>{`.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Nourishing L`}</strong>{` from blonde guy near shop. Purchase all 3 `}<strong parentName="p">{`L Stones`}</strong>{` from guy by Tavern. Complete quest to the top-right by windmill for `}<strong parentName="p">{`$22000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch2-start"
    }}>{`Alfyn Ch.2 Start`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Magic L`}</strong>{` and `}<strong parentName="p">{`Sharp M`}</strong>{` from Lysa.`}<br parentName="p"></br>{`
`}{`Inquire guy in top part of town and TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 of each herb`}</li>
        <li parentName="ul">{`1 Purifying Dust`}</li>
        <li parentName="ul">{`3 Injurious Dust`}</li>
      </ul>
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`All Gold Items, `}<strong parentName="li">{`Black Staff`}</strong>{`, `}<strong parentName="li">{`Giant's Club`}</strong>{`, `}<strong parentName="li">{`Mattias's Scepter`}</strong>{`, `}<strong parentName="li">{`Master's Longbow`}</strong>{`.`}</li>
        <li parentName="ul">{`Monster Perfume if you got one as a drop :(`}</li>
      </ul>
      <p>{`You want to have around $67000 to be safe.`}</p>
    </Menu>
    <p>{`Talk to orange bubble NPC, buy River Blossom from child, talk to kid above to complete quest for `}<strong parentName="p">{`Badge of Friendship`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <p>{`Get `}<strong parentName="p">{`Thief Shrine`}</strong>{`, then do this menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-2"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Nourishing L`}</li>
        <li parentName="ul">{`Ophilia: Magic L, Sharp M`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-6"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: -Adamantite Shield`}</li>
        <li parentName="ul">{`Therion: Badge of Friendship`}</li>
        <li parentName="ul">{`Alfyn: Optimize, Mighty Belt`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-5"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: 2 Merchant Skills, `}<strong parentName="li">{`Warrior`}</strong></li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Cleric`}</strong>{`, 4 Skills, `}<strong parentName="li">{`Merchant`}</strong>{`, Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Thief`}</strong>{`, 4 Skills`}</li>
      </ul>
      <h5 {...{
        "id": "skill"
      }}>{`Skill`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: -Evasive Maneuvers +Snatch`}</li>
        <li parentName="ul">{`Therion: Evil Ward, Endless Items, The Show Goes On`}</li>
        <li parentName="ul">{`Alfyn: Hang Tough`}</li>
      </ul>
    </Menu>
    <p>{`Pick `}<strong parentName="p">{`Pom S`}</strong>{` from the chest.`}</p>
    <p>{`Can choose to S&Q, or YOLO. And if YOLO, can kill or run.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Orewell battle back 2 birds are weak to Lightning & Sword. Front one is weak to Axe, Spear, Dagger, and has high evasion. I recommend skipping the break and killing with Lightning Blasts. Lightning Blast x6 is ~600 short, x7 kills.`}</p>
    </blockquote>
    <p>{`Tag `}<strong parentName="p">{`Orewell`}</strong>{`, and go to `}<strong parentName="p">{`Riverford`}</strong>{`.`}</p>
    <p>{`Complete quest (guy to the right) for `}<strong parentName="p">{`$15000`}</strong>{` + `}<strong parentName="p">{`Revitalizing Jam`}</strong>{`. Buy `}<strong parentName="p">{`Nourishing L, Tough L`}</strong>{` from guy near right exit.`}</p>
    <p>{`TP `}<strong parentName="p">{`Duskbarrow`}</strong>{` or `}<strong parentName="p">{`Victor's Hollow`}</strong>{` and run to `}<strong parentName="p">{`Shrine of the Archmagus`}</strong>{`. `}<strong parentName="p">{`Victor's Hollow`}</strong>{` is about 12s slower but is much less likely to get a battle on the way to the shrine.`}</p>
    <h4 {...{
      "id": "shrine-of-the-archmagus"
    }}>{`Shrine of the Archmagus`}</h4>
    <p>{`Pick `}<strong parentName="p">{`$20000, Wizard's Rod`}</strong>{` before Dreisang. You want to kill an encounter in here.`}</p>
    <blockquote>
      <p parentName="blockquote">{`This fight is pretty adaptable in terms of turn order to save resources.`}<br parentName="p"></br>{`
`}{`Only person that needs healing in this fight is Therion if he gets hit.`}<br parentName="p"></br>{`
`}{`If he does get hit, you can skip Ophilia Defend T2 and use the extra turn for a Grape M to try to save the Revitalizing Jam.`}</p>
    </blockquote>
    <h4 {...{
      "id": "dreisang-171469hp-66sp"
    }}>{`Dreisang 171469HP (66SP)`}</h4>
    <h5 {...{
      "id": "turn-1-7"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Pom M Merchant 1`}</li>
      <li parentName="ul">{`Alfyn: Spearhead`}</li>
      <li parentName="ul">{`Merchant 1: Pom L Merchant 2`}</li>
      <li parentName="ul">{`Merchant 2: Armor Corrosive x3`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-7"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Thousand Spears`}</li>
      <li parentName="ul">{`Ophilia: Defend / Pom L Merchant 1 / Grape M Therion if needed`}</li>
      <li parentName="ul">{`Merchants: HHVx4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Prioritize the Pom L on Merchant 1 above all else. Needs to be done after they take their turn T2, and is the only thing that is turn order dependant. If you can't get it off, Revitalizing Jam Merchant 2 and treat them like Merchant 1. Who uses the items this turn doesn't matter. For reference, Merchant 1 is the one that `}<strong parentName="p">{`didn't`}</strong>{` Armor Corrosive T1.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Pom L Merchant 1`}</li>
      <li parentName="ul">{`Alfyn: Pom M Merchant 2`}</li>
      <li parentName="ul">{`Therion: L Stone / HHVx4 if Merchant 1`}</li>
      <li parentName="ul">{`Tressa: L Stone / HHVx3 if Merchant 1`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Lightning Blast x2`}</li>
      <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Sword`}</strong>{` x4`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Tressa: Collect x4`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Therion: HHVx4`}</li>
      <li parentName="ul">{`Ophilia: Lightning Blast x4`}</li>
      <li parentName="ul">{`Alfyn: Purifying Dust + Essence of Pomegranite`}</li>
      <li parentName="ul">{`Tressa: L Stone`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Lightning Blast x3`}</li>
      <li parentName="ul">{`Alfyn: Amputation x4`}</li>
      <li parentName="ul">{`Therion: HHVx3 / HHVx4 if Merchant 2`}</li>
      <li parentName="ul">{`Tressa: HHVx4`}</li>
    </ul>
    <p>{`If you haven't already, pick `}<strong parentName="p">{`Wizard's Rod`}</strong>{`. TP `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch2-continued"
    }}>{`Tressa Ch.2 Continued`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Fool's Gold Ore x2 (100%)`}</strong>{` from woman standing in front of house.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-6"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Sorcerer`}</strong>{`, Lux Congerere + Elemental Break`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Scholar`}</strong>{`, 4 Scholar Skills total, `}<strong parentName="li">{`Dancer`}</strong>{`, Peacock Strut + Mole Dance`}</li>
      </ul>
      <h5 {...{
        "id": "skills-4"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: -Endless Items -Heightened Senses, +Percipience +The Show Goes On`}</li>
      </ul>
    </Menu>
    <p>{`Kill battle inside Manse. Fireball kills anything but birds, Lightning Blast kills everything.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Hasty Helm`}</strong>{` inside the second door you run past on the second screen of Morlock's Manse.`}</p>
    <h4 {...{
      "id": "omar-62sp"
    }}>{`Omar (62SP)`}</h4>
    <h5 {...{
      "id": "turn-1-8"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break x2`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Ophilia `}<strong parentName="li">{`(CHECK CURSOR)`}</strong></li>
    </ul>
    <h5 {...{
      "id": "turn-2-8"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Donate BPx3`}</li>
      <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Spear`}</strong>{` x3`}</li>
      <li parentName="ul">{`Ophilia: Glacies Claudere x4`}</li>
      <li parentName="ul">{`Tressa: Donate BP x3`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Holy Light x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong></p>
    <h3 {...{
      "id": "tressa-ch3-start"
    }}>{`Tressa Ch.3 Start`}</h3>
    <p>{`Purchase/Steal `}<strong parentName="p">{`Curious Bloom (80%)`}</strong>{` from woman near the item shop.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Edbart's Shield`}</strong>{` and `}<strong parentName="p">{`Plate Shield`}</strong>{` from story guy.`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h4 {...{
      "id": "therion-ch2-continued"
    }}>{`Therion Ch.2 Continued`}</h4>
    <p>{`Steal `}<strong parentName="p">{`Curious Bloom`}</strong>{` and `}<strong parentName="p">{`Heavy Coin Pouch`}</strong>{` from man standing to the left of Oasis Water guy.`}<br parentName="p"></br>{`
`}{`Inquire & Pick `}<strong parentName="p">{`Curious Antique`}</strong>{`. Steal `}<strong parentName="p">{`Pom S, Invig Nut M, Elemental Heavy Armor (80%)`}</strong>{` from man standing near Wyvern Scale guy. After stealing `}<strong parentName="p">{`Wyvern Scale`}</strong>{` TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch3-continued"
    }}>{`Tressa Ch.3 Continued`}</h3>
    <p>{`Kill battle here.`}<br parentName="p"></br>{`
`}<em parentName="p">{`Optional: Pick `}<strong parentName="em">{`Pom L`}</strong>{` after 6th torch.`}</em><br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$15000`}</strong>{` (red chest off to the right).`}</p>
    <h4 {...{
      "id": "venomtooth-tiger-92-sp"
    }}>{`Venomtooth Tiger (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-9"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Ignis Ardere`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
      <li parentName="ul">{`Therion: Bow / Wildfire / Fire M / Light M (M Stone makes Collect 100%).`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Ophilia`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-9"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Injurious Seed + Noxroot / Thousand Spears if Therion missed.`}</li>
      <li parentName="ul">{`Ophilia: Elemental Break`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-4"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Collect x4 (99%)`}</li>
      <li parentName="ul">{`Ophilia: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Therion: HHVx4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Grandport`}</strong></p>
    <h3 {...{
      "id": "tressa-ch4"
    }}>{`Tressa Ch.4`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Lapis Lazuli`}</strong>{` from man in blue hat near the entrance (should have $58,000 left over).`}<br parentName="p"></br>{`
`}{`Go to weapon shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-3"
      }}>{`Buy`}</h5>
      <p>{`Unerring Bracelet`}</p>
      <h5 {...{
        "id": "sell-2"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Gold Items`}</li>
        <li parentName="ul">{`Omar's Axe`}</li>
        <li parentName="ul">{`Wizard's Rod`}</li>
      </ul>
      <p>{`Want to have at least $61500, $62000 to be safe after selling and buying Lapis.`}<br parentName="p"></br>{`
`}{`You can sell Olive L's for 4k if you're short.`}</p>
      <h5 {...{
        "id": "equipment-7"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: -Empowering Necklace +Unerring Bracelet`}</li>
        <li parentName="ul">{`Tressa: Empowering Necklace, Elemental Heavy Armor`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`-Empowering Bracelet`}</strong></li>
        <li parentName="ul">{`Alfyn: -Mighty Belt +Empowering Bracelet (Optional)`}</li>
      </ul>
    </Menu>
    <p>{`Steal `}<strong parentName="p">{`M Stones`}</strong>{` and `}<strong parentName="p">{`L Stones`}</strong>{` from merchant in Bazaar.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-3"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Nourish L, Invig M`}</li>
        <li parentName="ul">{`Heal to full`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "esmeralda-92-sp"
    }}>{`Esmeralda (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-10"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break x2`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
      <li parentName="ul">{`Therion: Pom L Ophilia`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Ophilia`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-10"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Thousand Spears`}</li>
      <li parentName="ul">{`Ophilia: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive`}</li>
      <li parentName="ul">{`Tressa: Donate BP Ophilia`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-5"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Ignis Ardere x3`}</li>
      <li parentName="ul">{`Tressa/Therion: HHVx4`}</li>
      <li parentName="ul">{`Alfyn: Amputation x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Phase 2 weaknesses are Sword, Bow, Fire, Lightning, Wind`}</p>
    </blockquote>
    <p>{`After credits TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch2-continued"
    }}>{`Alfyn Ch.2 Continued`}</h3>
    <h4 {...{
      "id": "vanessa-92-sp"
    }}>{`Vanessa (92 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`You can Collect Vanessa for 12k by having Therion Donate BP T1, and having Alfyn Pom M Ophilia.`}<br parentName="p"></br>{`
`}{`Then T2 Therion does Donate BP x3 and Tressa Defends and does Collect x4 T3.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-11"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break x2`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Ophilia`}</li>
    </ul>
    <h6 {...{
      "id": "turn-2-11"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Ophilia: Glacies x4`}</li>
      <li parentName="ul">{`Tressa/Therion: Donate BP x3 Ophilia`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-6"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Ophilia: Ignis Ardere x4`}</li>
    </ul>
    <p>{`Go to `}<strong parentName="p">{`Moonstruck Coast`}</strong>{`. Steal `}<strong parentName="p">{`Primeval Robe (100%)`}</strong>{` from woman near the tent. Complete Sidequest: In Search of Father (II) (Talk to Kit).`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch2-continued-2-electric-boogaloo"
    }}>{`Therion Ch.2 Continued 2: Electric Boogaloo`}</h3>
    <h4 {...{
      "id": "orlick-92-sp"
    }}>{`Orlick (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-12"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break x2`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Ophilia`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Note: at LVL29 Full healing Ophilia's SP before her action T2 leaves her 1SP short for Gideon.`}</p>
    </blockquote>
    <h6 {...{
      "id": "turn-2-12"
    }}>{`Turn 2`}</h6>
    <ul>
      <li parentName="ul">{`Alfyn: Refreshing Jam Ophilia (Can Plum M if she leveled off Vanessa)`}</li>
      <li parentName="ul">{`Ophilia: Ignis x4`}</li>
      <li parentName="ul">{`Tressa/Therion: Donate BP x3 Ophilia`}</li>
    </ul>
    <h6 {...{
      "id": "turn-3-7"
    }}>{`Turn 3`}</h6>
    <ul>
      <li parentName="ul">{`Ophilia: Lux Congerere x4`}</li>
    </ul>
    <p>{`In Bolderfall, go to lower screen and steal `}<strong parentName="p">{`Magic M`}</strong>{` from Omar.`}</p>
    <p><strong parentName="p">{`Then go to Tavern and do this menu`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "change-party-1"
      }}>{`Change Party`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus > Alfyn`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-8"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Unequip All`}</li>
        <li parentName="ul">{`Tressa: -Empowering Necklace +Empowering Bracelet`}</li>
        <li parentName="ul">{`Therion: Empowering Bracelet (Optional)`}</li>
        <li parentName="ul">{`Cyrus: Optimize, Empowering Necklace, Empowering Bracelet`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch2"
    }}>{`Cyrus Ch.2`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Fort M`}</strong>{` from lady by stairs.`}</p>
    <p><em parentName="p">{`Quiz Option 2, Option 2, Option 2`}</em></p>
    <h4 {...{
      "id": "gideon-92-sp"
    }}>{`Gideon (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-13"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break x2`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Tressa: Peacock Ophilia`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-13"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Cyrus: Healing Grape Self / Attack`}</li>
      <li parentName="ul">{`Tressa/Therion: Donate BP x3 Ophilia `}<strong parentName="li">{`(CHECK CURSOR AFTER CYRUS GRAPE)`}</strong></li>
    </ul>
    <h5 {...{
      "id": "turn-3-8"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Ignis x4 (if LV30) / Lux Congerere x4`}</li>
    </ul>
    <p>{`Steal `}<strong parentName="p">{`Fort M`}</strong>{` from lady by stairs if you didn't earlier.`}</p>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch3"
    }}>{`Cyrus Ch.3`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Fire L (80%)`}</strong>{` from Tobias.`}<br parentName="p"></br>{`
`}<em parentName="p">{`Quiz: Option 3, Option 3.`}</em><br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Light L, Shadow L (80%)`}</strong>{` from man to the left of the fountain in Stonegard Heights.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "inventory-1"
      }}>{`Inventory`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Tough L`}</li>
        <li parentName="ul">{`Ophilia: Magic M`}</li>
        <li parentName="ul">{`Heal HP and SP if needed`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Tonitrus Canere + Ventus Saltare`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Elemental Aid + Stronger Strikes`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "yvon-164-sp"
    }}>{`Yvon (164 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-14"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break x2`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Therion: Pom M Ophilia`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Ophilia`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-14"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Attack x3 Yvon (can miss)`}</li>
      <li parentName="ul">{`Ophilia: Tonitrus Canere x3`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Donate BPx3 Ophilia`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-9"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Collect x4`}</li>
      <li parentName="ul">{`Ophilia: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Therion: L Stone`}</li>
      <li parentName="ul">{`Cyrus: S Stone or something (range at LVL30)`}</li>
    </ul>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-9"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Unequip All`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Bolderfall`}</strong>{`, run to S'warkii.`}</p>
    <h3 {...{
      "id": "haanit-ch1"
    }}>{`H'aanit Ch.1`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "swap"
      }}>{`Swap`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn > Cyrus`}</li>
        <li parentName="ul">{`H'aanit > Tressa`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "ghisarma-72-sp"
    }}>{`Ghisarma (72 SP)`}</h4>
    <ul>
      <li parentName="ul">{`Glacies x3 or x2 + L Stone`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Bolderfall`}</strong>{`.`}</p>
    <p>{`Optionally Steal Pom L from Alphas. Provoke Alphas and use Fire L or Shadow L.`}</p>
    <p>{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch3-start"
    }}>{`Alfyn Ch.3 Start`}</h3>
    <p>{`Optionally pick `}<strong parentName="p">{`Pom M`}</strong>{` after cutscene. Steal `}<strong parentName="p">{`Poms`}</strong>{` from guy by screen transition.`}<br parentName="p"></br>{`
`}{`Go to Tavern, trigger cutscene. After cutscene TP `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch3-start"
    }}>{`Therion Ch.3 Start`}</h3>
    <p>{`Go to Tavern, Steal `}<strong parentName="p">{`Bottle of Wine`}</strong>{`.`}</p>
    <p>{`Talk to Tavern Keeper, swap Tressa > H'aanit.`}<br parentName="p"></br>{`
`}{`Continue story, after cutscene at Black Market TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch3-continued"
    }}>{`Alfyn Ch.3 Continued`}</h3>
    <p>{`Talk to Lyblac. Inquire Alphas. Proceed with story.`}<br parentName="p"></br>{`
`}{`Inquire lady for story. Finish Daughter of the Dark God II.`}<br parentName="p"></br>{`
`}{`Go into the church, purchase `}<strong parentName="p">{`Battle-Tested Staff`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch3-continued"
    }}>{`Therion Ch.3 Continued`}</h3>
    <p>{`Kill mandatory mob with Ignis x2 or Luminescence x2`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-4"
      }}>{`Items`}</h5>
      <p>{`Heal Ophi SP if needed`}</p>
      <h5 {...{
        "id": "equipment-10"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Gideon's Dagger (optional), Adamantite Shield, -Badge of Friendship +Empowering Bracelet (x2)`}</li>
        <li parentName="ul">{`Ophilia: Optimize, -Unerring Bracelet +Empowering Necklace`}</li>
        <li parentName="ul">{`Alfyn: Optimize, Badge of Friendship, Empowering Bracelet`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "gareth-144-sp"
    }}>{`Gareth (144 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`This fight is like Elemental Aid Vanessa now, except you want to break.`}<br parentName="p"></br>{`
`}{`Improvise based on turn order :)`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-15"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Glacies xMAX`}</li>
      <li parentName="ul">{`Alfyn: Injurious Seed + Essence of Grape / Wind L / Pom M Ophi`}</li>
      <li parentName="ul">{`Therion: Defend / Donate BP`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut`}</li>
      <li parentName="ul"><em parentName="li">{`If Ophi first, Glacies x2 + Wind L to kill adds.`}</em></li>
    </ul>
    <h5 {...{
      "id": "turn-2-15"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Ignis x4`}</li>
      <li parentName="ul">{`Merchant: Donate BP x3`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Wispermill`}</strong>{` and head to `}<strong parentName="p">{`Shrine of the Starseer`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <p>{`Heal HP and SP if needed.`}</p>
      <h5 {...{
        "id": "jobs-7"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Tenebrae Operire`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Hunter`}</strong></li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Cleric`}</strong>{`, All Cleric skills`}</li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Dancer`}</strong>{`, Peacock Strut + Panther Dance`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-1"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Augmented Elements`}</li>
        <li parentName="ul">{`Alfyn: -Endless Items +The Show Goes On`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "steorra-starseer-144-sp"
    }}>{`Steorra, Starseer (144 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`This turn is kind of hard to explain, so I'll just list the goals of the turn.`}</p>
      <ol parentName="blockquote">
        <li parentName="ol">{`Get Leghold up. This can be done through Leghold or Injurious Dust + Curious Bloom, which also breaks a shield.`}</li>
        <li parentName="ol">{`Heal / prevent status. Anyone can heal with Herb of Clarity, Alfyn can prevent with Soothing dust + Curious bloom.`}</li>
        <li parentName="ol">{`Set up turn 2 Aelfics. You need to Pom Therion & defend with him if he's after Ophilia. Worst case, you can Soothing Seed + Curious Bloom Therion to put him before Ophilia.`}</li>
        <li parentName="ol">{`Break 1 shield off Steorra. Can be done with any character that has a free turn. This can also be done next turn.`}</li>
      </ol>
      <p parentName="blockquote">{`Despite all this text, this fight is pretty easy. You generally have multiple free turns. Just need to get a feel for it.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-16"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Heal status / Pom S Therion / Fire/Ice/Thunder M / Ignis`}</li>
      <li parentName="ul">{`Tressa: Heal status / Leghold / Donate BP Therion`}</li>
      <li parentName="ul">{`Therion: Defend / Heal status / Pom S self`}</li>
      <li parentName="ul">{`Alfyn: Soothing Dust + Curious Bloom / Heal Status / Injurious Dust + Curious Bloom`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Take note of whether or not Alfyn Peacocks Ophilia before she does Ignis`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-16"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aelfics Ophilia`}</li>
      <li parentName="ul">{`Ophilia: Ignis Ardere`}</li>
      <li parentName="ul">{`Tressa: Mercenaries if you need to break shield / Grape M`}</li>
      <li parentName="ul">{`Alfyn: Peacock Strut x2 Ophilia`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Revitilizing Jam has to be after Ophilia's turn. If Ophilia is last, have Therion defend and use it T4. Therion's turn is the least valuable T4.`}<br parentName="p"></br>{`
`}{`Note that if you used Revitalizing Jam for Dreisang, you need to use a Pom L + Refreshing Jam instead.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-3-10"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Tressa: Collect x4`}</li>
      <li parentName="ul">{`Therion: Grape M if not done already / Revitalizing Jam Ophilia / Defend`}</li>
      <li parentName="ul">{`Alfyn: Grape M if not done already / Revitalizing Jam Ophilia / Defend`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Fight changes depending on amount of shield on Steorra. 4S is free, 8S is slightly harder, 12S is the worst one.`}<br parentName="p"></br>{`
`}{`You need someone between Ophilia T4 and T5 to give him 1 BP. Should always be possible with 4 & 8 shields, and possible most of the time with 12 shields.`}<br parentName="p"></br>{`
`}{`If you need to use Revitilizing Jam, try to use it with Therion.`}<br parentName="p"></br>{`
`}{`If you get 12S, someone needs to be able to give Ophilia 1BP between his turns T4 and T5. If not, you need an extra 2 L Stones + Amputation to kill. In this case, you might just want to have Tressa Leghold T4, finish break T5, and finish T6 with a Holy Light or something.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-4-1"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Pay attention to number of shields Steorra has left`}</strong></li>
      <li parentName="ul">{`Ophilia: Tenebrae x4 (4), Tonitrus x4 (8), Ignis x4 (12)`}</li>
      <li parentName="ul">{`Tressa: Defend / Donate BP (4/8), Rain of Arrows (12)`}</li>
      <li parentName="ul">{`Alfyn: Rev Jam if needed / Injurious Seed + Plum (8), Injurious Seed + Curious Bloom (12) / Defend`}</li>
      <li parentName="ul">{`Therion: Rev Jam if needed / Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-1"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Ignis x4`}</li>
      <li parentName="ul">{`Alfyn: Amputation x4 (if 8 or 12 shield & no peacock before Ophilia's turn T2)`}</li>
      <li parentName="ul">{`Rest: Pom S Ophilia if needed.`}</li>
    </ul>
    <hr></hr>
    <p>{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h4 {...{
      "id": "alfyn-ch3-continued-pt2"
    }}>{`Alfyn Ch.3 Continued pt.2`}</h4>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-8"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Starseer`}</strong>{`, 3 Skills, `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold Trap`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Dancer`}</strong></li>
      </ul>
      <h5 {...{
        "id": "support-skills-2"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: -Hale & Hearty +Hard Worker`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "miguel-92-sp"
    }}>{`Miguel (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-17"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break`}</li>
      <li parentName="ul">{`Tressa: Peacock`}</li>
      <li parentName="ul">{`Therion: Defend / Pom S `}<strong parentName="li">{`Self`}</strong>{` if before Ophilia T2`}</li>
      <li parentName="ul">{`Alfyn: Pom S `}<strong parentName="li">{`Therion`}</strong>{` / Leghold Trap if Therion & Miguel before Ophilia T2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-17"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aelfics Ophilia`}</li>
      <li parentName="ul">{`Ophilia: 3x Ventus`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Pay attention to Ophi's JP after this fight.`}<br parentName="p"></br>{`
`}{`If < 2630, need to kill something in Alfyn 4 / Warbringer`}<br parentName="p"></br>{`
`}{`TODO: Threshold for BP Eater`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`Orewell`}</strong></p>
    <h3 {...{
      "id": "alfyn-ch4"
    }}>{`Alfyn Ch.4`}</h3>
    <p>{`Two one-text-box cutscenes, press A instead of skipping to immediately gain control afterwards.`}</p>
    <h4 {...{
      "id": "ogre-eagle-164-sp"
    }}>{`Ogre Eagle (164 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`There's lots of ways to get little bonuses here. I recommend playing with this fight to get a feel for it.`}<br parentName="p"></br>{`
`}{`Assuming min damage, you need an L Stone + an Amputation x4 / M Stone to kill. With Summon Strengh on Alfyn, you can kill with Amputation x4 + M Stone but you'd have to give up The Show Goes On which gives you status immunity T2 with Curious Mist T1.`}<br parentName="p"></br>{`
`}{`With Elemental Break you don't need any extra damage from Therion / Alfyn.`}<br parentName="p"></br>{`
`}{`With broken shield T1 Amputation + M Stone does enough damage.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-18"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Pom S/M Therion / can Elemental Break if Therion before Ophilia`}</li>
      <li parentName="ul">{`Alfyn: Soothing Dust + Curious Bloom / Injurious Dust + Curious Bloom or Leghold / Pom M Ophilia or Icicle`}</li>
      <li parentName="ul">{`Therion: Defend / Pom S Self / Aelfics`}</li>
      <li parentName="ul">{`Tressa: Peacock Ophilia`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-18"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aelfics Ophilia`}</li>
      <li parentName="ul">{`Ophilia: Glacies x3`}</li>
      <li parentName="ul">{`Tressa: Donate BP Ophilia / Defend if last next turn or she's after Ophilia T3 and Ignis will kill next turn.`}</li>
      <li parentName="ul">{`Alfyn: Conoct Purifying Seed + Essence of Pomegranate Ophilia / Pom M Ophilia / Pom L if Tressa can't Donate BP`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-11"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Collect x4`}</li>
      <li parentName="ul">{`Ophilia: Ignis Ardere x4`}</li>
      <li parentName="ul">{`Therion: L Stone`}</li>
      <li parentName="ul">{`Alfyn: Amputation x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Watch Ophilia's JP after Ogre Eagle. Need `}<strong parentName="p">{`4630`}</strong>{` for `}<strong parentName="p">{`Surpassing Power.`}</strong></p>
    </blockquote>
    <p>{`If you're short `}<strong parentName="p">{`Curious Blooms`}</strong>{`, steal 1 from the guy by Clearbrook tavern.`}</p>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`, go to `}<strong parentName="p">{`Shrine of the Warbringer`}</strong>{`.`}</p>
    <p>{`Optionally pick `}<strong parentName="p">{`$30000`}</strong>{`, based on money / if you need encounter.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-9"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Warrior`}</strong>{`, All Warrior Skills, `}<strong parentName="li">{`Sorcerer`}</strong></li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Dancer`}</strong></li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Scholar`}</strong>{`, All Scholar Skills`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-3"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: -Evasive Maneuvers, +Surpassing Power`}</li>
        <li parentName="ul">{`Tressa: -Snatch +Evasive Maneuvers`}</li>
      </ul>
      <p>{`Heal HP and Ophilia SP`}</p>
    </Menu>
    <h4 {...{
      "id": "winnehild-warbringer-164sp"
    }}>{`Winnehild, Warbringer (164SP)`}</h4>
    <h5 {...{
      "id": "turn-1-19"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Glacies`}</li>
      <li parentName="ul">{`Alfyn: Injurious Dust + Curious Bloom`}</li>
      <li parentName="ul">{`Therion: Shackle Foe / Heal / Herb of Healing`}</li>
      <li parentName="ul">{`Tressa: HHM / Heal / Herb of Healing`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If Therion, Tressa, or Alfyn is before Ophilia T2 and T3, you can break Winnehild with them to guarantee that Elemental Break doesn't miss.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-19"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break`}</li>
      <li parentName="ul">{`Alfyn: Peacock Ophilia`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-12"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aelfrics Ophilia`}</li>
      <li parentName="ul">{`Tressa: Alephans Ophilia`}</li>
      <li parentName="ul">{`Ophilia: Ignis x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Everhold`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-10"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Warmaster`}</strong>{`, 2 Skills, `}<strong parentName="li">{`Cleric`}</strong></li>
      </ul>
      <h5 {...{
        "id": "support-skills-4"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: -Cover +Boost-Start`}</li>
        <li parentName="ul">{`Therion: +Extra Experience`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Shrine of the Runeblade`}</strong>{`. Everhold encounter Ignis x2. If Tressa first you can break with Dancer x2.`}<br parentName="p"></br>{`
`}{`Heal to full.`}</p>
    <h4 {...{
      "id": "balogar-the-runeblade-164-sp"
    }}>{`Balogar, The Runeblade (164 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-20"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Tenebrae Operire`}</li>
      <li parentName="ul">{`Alfyn: Peacock Strut Ophilia`}</li>
      <li parentName="ul">{`Therion: Pom M Tressa`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-20"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Bandits x2`}</li>
      <li parentName="ul">{`Ophilia: Elemental Break`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Alfyn: Soothing Seed + Curious Bloom `}<strong parentName="li">{`Tressa`}</strong>{` / Panther Dance if learned & puts Tressa before Ophilia / Nothing`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-13"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephans`}</li>
      <li parentName="ul">{`Therion: Aelfics`}</li>
      <li parentName="ul">{`Ophilia: Ignis x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If you skipped Collect on Ogre Eagle, pick `}<strong parentName="p">{`$50000`}</strong>{` chest.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-11"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Knowledge Staff, -Empowering Necklace +Stimulating Bracelet`}</li>
        <li parentName="ul">{`Alfyn: Unequip All`}</li>
        <li parentName="ul">{`Therion: Gareth's Helm, Primeval Robe`}</li>
        <li parentName="ul">{`Tressa: Badge of Friendship`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch1"
    }}>{`Olberic Ch.1`}</h3>
    <p>{`Replace Alfyn with Olberic`}</p>
    <p>{`Mandatory fight: Ophilia Luminescence / Tressa Fireball x2 / M Stone`}</p>
    <h4 {...{
      "id": "gaston-72sp"
    }}>{`Gaston (72SP)`}</h4>
    <p>{`Ophilia: Ignis x2`}</p>
    <p>{`TP to `}<strong parentName="p">{`Victor’s Hollow`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <p>{`Note: you can delay this equip menu until after Victorino if you have a extra Wind L to throw for Victorino. Ophilia 1st + Wind L is faster than a really late Ophilia.`}</p>
      <h5 {...{
        "id": "equipment-12"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: BT Staff`}</li>
        <li parentName="ul">{`Olberic: Optimize`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-11"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Dancer`}</strong></li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Starseer`}</strong>{`, 3 Skills, `}<strong parentName="li">{`Cleric`}</strong></li>
        <li parentName="ul">{`Olberic: `}<strong parentName="li">{`Merchant`}</strong>{`, Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-5"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Therion: -Endless Items -The Show Goes On +Boost-Start +Hard Worker`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "olberic-ch2"
    }}>{`Olberic Ch.2`}</h3>
    <p>{`Challenges: HHV`}</p>
    <p>{`Victorino: Ventus x3 or Ventus x2 + L Stone or Ignis x4 w/ BT Staff`}</p>
    <p>{`Joshua: Lux x4 or Lux x3 + Peacock`}<br parentName="p"></br>{`
`}{`Archibold: Tenebrae x4 or Tenebrae x3 + Peacock (Tenebrae x4 is rangy, try to get a little bit of extra damage in.)`}</p>
    <h4 {...{
      "id": "gustav"
    }}>{`Gustav`}</h4>
    <blockquote>
      <p parentName="blockquote">{`If you get Peacock + a Pom L before Ophilia T1, you can kill with Ignis x3 & Ignis x4`}<br parentName="p"></br>{`
`}{`If you get one of them, a 2xIgnis with Peacock or a 3xIgnis + 4xIgnis + Fire M kills`}<br parentName="p"></br>{`
`}{`If you get Ophilia first, it would take an extra L + M Stone at least. The L might need to be Fire or Shadow. I recommend just reverting to Aelfics in this scenario.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-21"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Glacies Claudere x2 / Ignis x3`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Ophilia`}</li>
      <li parentName="ul">{`Therion/Olberic: Pom L Ophilia`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-21"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Ignis Ardere x4`}</li>
      <li parentName="ul"><em parentName="li">{`Aelfics/Fire M if necessary`}</em></li>
    </ul>
    <p>{`After the fight, TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`. Purchase `}<strong parentName="p">{`Fort L`}</strong>{` from Tim.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`, finish the chapter.`}</p>
    <p>{`TP to `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch3"
    }}>{`Olberic Ch.3`}</h3>
    <Menu mdxType="Menu">
      <p>{`Restore SP if necessary`}</p>
      <h5 {...{
        "id": "equipment-13"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Knowledge Staff`}</li>
        <li parentName="ul">{`Olberic: Unequip all`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Remove Dagger`}</strong></li>
      </ul>
    </Menu>
    <p>{`144 SP Ophilia, Ignis x2 both Lizard fights`}</p>
    <blockquote>
      <p parentName="blockquote">{`Ophi needs at least 7400JP after Lizards, else take an extra fight here or in Olberic 4.`}</p>
    </blockquote>
    <h4 {...{
      "id": "lizardman-chief-7292-sp"
    }}>{`Lizardman Chief (72/92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-22"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend if before Therion / Elemental Break / Pom S Self`}</li>
      <li parentName="ul">{`Tressa: Peacock Strut Ophilia`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Olberic: Pom S Ophilia / Nothing`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-22"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aelfrics Ophilia`}</li>
      <li parentName="ul">{`Ophilia: Tonitrus Canere x3/4`}</li>
    </ul>
    <h4 {...{
      "id": "erhardt"
    }}>{`Erhardt`}</h4>
    <ol>
      <li parentName="ol">{`Shadow L`}</li>
      <li parentName="ol">{`Defend`}</li>
      <li parentName="ol">{`HHVx4`}</li>
    </ol>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch4"
    }}>{`Olberic Ch.4`}</h3>
    <p><strong parentName="p">{`After the cutscene on the second screen, TP Sunshade`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`In Sunshade, talk to Ali to start quest.`}</strong>{` Then TP back to `}<strong parentName="p">{`Riverford`}</strong>{`.`}</p>
    <p><strong parentName="p">{`Red Hat`}</strong>{`: Pom L, HHVx4, HHVx3 OR Pom M, Defend, HHVx4, HHVx3`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-12"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Starseer`}</strong>{`, 4 Skills, `}<strong parentName="li">{`Sorcerer`}</strong></li>
        <li parentName="ul">{`Olberic: 3 Merchant Skills, `}<strong parentName="li">{`Warrior`}</strong>{`, 2 Skills, `}<strong parentName="li">{`Thief`}</strong>{`, 3 Skills`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Starseer`}</strong>{`, 4 Skills, `}<strong parentName="li">{`Scholar`}</strong></li>
      </ul>
      <h5 {...{
        "id": "support-skills-6"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: -Augmented Elements -Stronger Strikes, +BP Eater +Boost Start `}</li>
        <li parentName="ul">{`Tressa: -The Show Goes On, +Boost Start`}</li>
        <li parentName="ul">{`Olberic: Fleetfoot, Cover, Hang Tough`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "werner-144-sp"
    }}>{`Werner (144 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`If someone got terrored delay break until T2 and kill T3.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-23"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Tonitrus`}</li>
      <li parentName="ul">{`Tressa/Therion: Defend`}</li>
      <li parentName="ul">{`Olberic: Dagger x2 / HP Thief if Terrored / Nothing if Ophilia before Werner T2 and no Werner actions left T1`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-23"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephans Ophilia`}</li>
      <li parentName="ul">{`Therion: Aelfrics Ophilia`}</li>
      <li parentName="ul">{`Ophilia: Ignis Ardere x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Highly recommend stealing the 55% accessories now, as money is a lot tighter skipping Winnehild Collect.`}</p>
    </blockquote>
    <p>{`Steal/Purchase `}<strong parentName="p">{`Sprightly Necklace (55%)`}</strong>{` from Noelle. TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <p>{`Go to tavern.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "change-party-2"
      }}>{`Change Party`}</h5>
      <ul>
        <li parentName="ul">{`H'aanit > Olberic`}</li>
        <li parentName="ul">{`Therion > Alfyn`}</li>
      </ul>
    </Menu>
    <p>{`Inquire Bishop Donovan in the cathedral.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <p>{`Purchase `}<strong parentName="p">{`Battle-Tested Blade`}</strong>{` from Erhardt (in the house from Olberic 3).`}<br parentName="p"></br>{`
`}{`Talk to Bale twice to complete sidequest: Back with Bale.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you want an extra Sharp M for Tressa, Steal `}<strong parentName="p">{`Sharp M`}</strong>{` from Bale.`}</p>
    </blockquote>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haanit-ch2"
    }}>{`H'aanit Ch.2`}</h3>
    <p>{`Go to the Tavern`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "change-party-3"
      }}>{`Change Party`}</h5>
      <ul>
        <li parentName="ul">{`Therion > Alfyn`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-14"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`H'aanit: Optimize, Empowering Bracelet x2`}</li>
        <li parentName="ul">{`Therion: Battle-tested Blade, Captain's Badge, Empowering Necklace`}</li>
        <li parentName="ul"><em parentName="li">{`If needed, Lizard King Axe to H'aanit`}</em></li>
      </ul>
    </Menu>
    <p>{`Nathan’s Bodyguard: Fire/Thunder L x2, M Stone`}</p>
    <p>{`Purchase `}<strong parentName="p">{`Double Tomohawk`}</strong>{` from Archibold (all the way to the right in Stonegard Valley)`}</p>
    <blockquote>
      <p parentName="blockquote">{`To have enough money for Viper Dagger after Prim 2, after buying Tomohawk you need`}<br parentName="p"></br>{`
`}{`Numbers assume 1 H'aanit 4 battle and 1 Prim 3 battle`}</p>
      <ul parentName="blockquote">
        <li parentName="ul"><strong parentName="li">{`24k`}</strong>{` to buy just `}<strong parentName="li">{`Battle-Tested Axe`}</strong></li>
        <li parentName="ul"><strong parentName="li">{`87k`}</strong>{` to buy `}<strong parentName="li">{`Viper Dagger`}</strong>{` with `}<strong parentName="li">{`no selling`}</strong></li>
        <li parentName="ul"><strong parentName="li">{`43.5k`}</strong>{` to buy `}<strong parentName="li">{`Viper Dagger`}</strong>{` with `}<strong parentName="li">{`selling weapons`}</strong></li>
        <li parentName="ul"><strong parentName="li">{`30k`}</strong>{` to buy `}<strong parentName="li">{`Viper Dagger`}</strong>{` with `}<strong parentName="li">{`selling weapons and Refreshing Jams`}</strong></li>
        <li parentName="ul"><strong parentName="li">{`38.5k`}</strong>{` to buy `}<strong parentName="li">{`Viper Dagger`}</strong>{` in `}<strong parentName="li">{`Duskbarrow`}</strong>{` if you `}<strong parentName="li">{`purchased Nuts`}</strong>{` without selling`}</li>
        <li parentName="ul"><strong parentName="li">{`20k`}</strong>{` to buy `}<strong parentName="li">{`Viper Dagger`}</strong>{` in `}<strong parentName="li">{`Duskbarrow`}</strong>{` if you `}<strong parentName="li">{`stole Nuts`}</strong>{` without selling`}</li>
      </ul>
    </blockquote>
    <p>{`Ancient One: Thunder/Fire/Light L, Any L`}</p>
    <h4 {...{
      "id": "lord-of-the-forest-92-sp"
    }}>{`Lord Of The Forest (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-24"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend if before Tressa`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Sword`}</strong>{` x3`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-24"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephan’s Ophilia`}</li>
      <li parentName="ul">{`Ophilia: Ignis Ardere x4`}</li>
    </ul>
    <p>{`Steal `}<strong parentName="p">{`Fortifying M (100%)`}</strong>{` from NPC before screen split to lower area. TP to `}<strong parentName="p">{`Stillsnow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haanit-ch3"
    }}>{`H'aanit Ch.3`}</h3>
    <p>{`Alaic: Fox, Shadow M, Shadow L, Thunder L w/ Lizardking Axe`}</p>
    <h4 {...{
      "id": "dragon-92-sp"
    }}>{`Dragon (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-25"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break`}</li>
      <li parentName="ul">{`H’aanit: Defend`}</li>
      <li parentName="ul">{`Therion: Holy Light / Nothing if Ophi before Dragon T2`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-25"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`H'aanit: Axe x3`}</li>
      <li parentName="ul">{`Tressa: Alephan’s Ophilia`}</li>
      <li parentName="ul">{`Ophilia: Ignis x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Marsalim`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haanit-ch4"
    }}>{`H'aanit Ch.4`}</h3>
    <p>{`Optional: Steal `}<strong parentName="p">{`2 Pom L`}</strong>{` from man standing by weapon shop.`}</p>
    <p><strong parentName="p">{`Before triggering cutscene in middle of town, GUIDE Maroof`}</strong></p>
    <h4 {...{
      "id": "redeye-144-sp"
    }}>{`Redeye (144 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-26"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Ignis Ardere`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`H'aanit: Bow x2 / Rain of Arrows / Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-26"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephans Ophilia`}</li>
      <li parentName="ul">{`Therion: Aelfrics Ophilia`}</li>
      <li parentName="ul">{`Ophilia: Ignis Ardere x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Sunshade`}</strong></p>
    <h3 {...{
      "id": "primrose-ch1"
    }}>{`Primrose Ch.1`}</h3>
    <p>{`Talk to Ali to complete sidequest: The Adventures of Ali.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-15"
      }}>{`Equipment`}</h5>
      <p>{`Unequip H'aaanit`}</p>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`If you want money for Viper Dagger, can sell weapons in shop here.`}<br parentName="p"></br>{`
`}{`Weapons sell for 43500, Refreshing Jams sell for 13500. Want about 144k after selling.`}</p>
    </blockquote>
    <p>{`Replace H’aanit with Primrose`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-16"
      }}>{`Equipment`}</h5>
      <p>{`Primrose: Optimize, Empowering Bracelet x2`}</p>
    </Menu>
    <h4 {...{
      "id": "helgenish-1872-sp"
    }}>{`Helgenish (18/72 SP)`}</h4>
    <p>{`Ophilia Ignis x2 or Luminescence x2`}</p>
    <p>{`TP `}<strong parentName="p">{`Stillsnow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch2"
    }}>{`Primrose Ch.2`}</h3>
    <h4 {...{
      "id": "rufus-the-left-hand-man-88-sp"
    }}>{`Rufus, The Left Hand Man (88 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-27"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Tonitrus x3/4`}</li>
      <li parentName="ul">{`Tressa: Donate BP x3 Ophilia`}</li>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Sword`}</strong>{` x2 IF Tonitrus x3`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-27"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Holy Light x3/4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`To skip Prim 3 Battle & get LVL45 Therion he needs to be > LVL42 1193EXP after Rufus`}</p>
    </blockquote>
    <h3 {...{
      "id": "primeval-bow"
    }}>{`Primeval Bow`}</h3>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <p>{`Talk to Alaic by the entrance and Guide him.`}</p>
    <p>{`Purchase `}<strong parentName="p">{`Battle-Tested Axe`}</strong>{` from Ned (down the stairs on the upper screen).`}</p>
    <p>{`Go into `}<strong parentName="p">{`Forest of No Return`}</strong>{`.`}</p>
    <p>{`If you have $61750, before talking to the bandit, buy `}<strong parentName="p">{`Viper Dagger`}</strong>{`.`}</p>
    <p>{`Sidequest: Again with Alaic (talk to the bandit, Tonitrus Canere x3)`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch3"
    }}>{`Primrose Ch.3`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-17"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Primeval Bow`}</li>
      </ul>
      <h5 {...{
        "id": "skills-5"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Peacock Strut + `}<strong parentName="li">{`Panther Dance`}</strong></li>
        <li parentName="ul">{`Therion: HP Thief (Speeds up next skill menu)`}</li>
      </ul>
      <p>{`Heal SP if needed.`}</p>
    </Menu>
    <h4 {...{
      "id": "albus-the-right-hand-man-72-sp"
    }}>{`Albus, The Right Hand Man (72 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-28"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Sword x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-28"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephan’s Ophilia`}</li>
      <li parentName="ul">{`Ophilia: Ventus Saltare x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Everhold`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch4"
    }}>{`Primrose Ch.4`}</h3>
    <p>{`Purchase/Steal `}<strong parentName="p">{`Sharp L`}</strong>{` and `}<strong parentName="p">{`Crit L`}</strong>{`.`}</p>
    <h4 {...{
      "id": "simeon-144-sp"
    }}>{`Simeon (144 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-29"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Tenebrae Operire`}</li>
      <li parentName="ul">{`Tressa/Therion: Defend`}</li>
      <li parentName="ul">{`Primrose: Heal / Nothing`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-29"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephan’s Ophilia`}</li>
      <li parentName="ul">{`Therion: Steal x4 from Dancer Marionette (100%)`}</li>
      <li parentName="ul">{`Ophilia: Ventus Saltare x4 Simeon`}</li>
    </ul>
    <h4 {...{
      "id": "simeon-the-puppet-master-92-sp"
    }}>{`Simeon, The Puppet Master (92 SP)`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Can 2T kill if Simeon silences Therion or Primrose. If he silences Ophilia or Tressa, have Ophilia use Herb of Clamor T2 and Primrose Peacock Strut.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-30"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Primrose: Attack x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-30"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Attack x4`}</li>
      <li parentName="ul">{`Tressa: Alephans Ophilia`}</li>
      <li parentName="ul">{`Ophilia: Ventus Saltare x4 / Herb of Clamor`}</li>
      <li parentName="ul">{`Primrose: Nothing / Peacock Strut`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-14"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Ventus Saltare x4`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Northreach`}</strong></p>
    <h4 {...{
      "id": "therion-ch4-start"
    }}>{`Therion Ch.4 Start`}</h4>
    <p>{`Purchase `}<strong parentName="p">{`Fortifying L`}</strong>{` and Steal `}<strong parentName="p">{`Platinum Sword`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`This is the last Nut you get in the run. Use nuts anytime you go into the inventory to heal.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "tavern-equipment"
      }}>{`Tavern Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Unequip all, Unerring Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "change-party-4"
      }}>{`Change Party`}</h5>
      <ul>
        <li parentName="ul">{`Primrose > Cyrus`}</li>
      </ul>
    </Menu>
    <p>{`Mandatory fight: Ophilia Ignis Ardere x2`}</p>
    <p>{`TP to `}<strong parentName="p">{`Duskbarrow`}</strong>{` after cutscene where Therion discovers the hideout`}</p>
    <h3 {...{
      "id": "cyrus-ch4"
    }}>{`Cyrus Ch.4`}</h3>
    <p><em parentName="p">{`Quiz: Option 2, Option 2, Option 2`}</em></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-13"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Runelord`}</strong>{`, All skills besides Balogar's Blade, `}<strong parentName="li">{`Sorcerer`}</strong></li>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Merchant`}</strong>{`, 4 Skills, `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold Trap`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Warrior`}</strong>{`, All skills except Divine, `}<strong parentName="li">{`Scholar`}</strong></li>
      </ul>
      <h5 {...{
        "id": "equipment-18"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Optimize, -Stimulating Bracelet +Empowering Bracelet, Vendetta Coat`}</li>
        <li parentName="ul">{`Tressa: Optimize`}</li>
        <li parentName="ul">{`Therion: Viper Dagger`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-7"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: -Boost Start, +Elemental Edge`}</li>
        <li parentName="ul">{`Tressa: -Grow on Trees +Cover`}</li>
        <li parentName="ul">{`Cyrus: Hang Tough`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "lucia-92-sp"
    }}>{`Lucia (92 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-31"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break`}</li>
      <li parentName="ul">{`Cyrus: Leghold Trap / Nothing if Ophilia before Lucia T2`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-31"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephans Ophilia`}</li>
      <li parentName="ul">{`Therion: Aelfrics Ophilia`}</li>
      <li parentName="ul">{`Ophilia: Ventus Saltare x3`}</li>
    </ul>
    <p>{`If you didn't buy `}<strong parentName="p">{`Viper Dagger`}</strong>{` yet, buy it from lady blocking house in south-west part of town.`}</p>
    <p><em parentName="p">{`Quiz: Option 2, Option 3, Option 2.`}</em></p>
    <h4 {...{
      "id": "atlasdam"
    }}>{`Atlasdam`}</h4>
    <p>{`Steal `}<strong parentName="p">{`Curious Bloom (100%)`}</strong>{` from man standing near the library to the south if you don't have one. Steal `}<strong parentName="p">{`Elemental Augementor (100%)`}</strong>{` from Therese inside the academy. TP `}<strong parentName="p">{`Northreach`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch4-continued"
    }}>{`Therion Ch.4 Continued`}</h3>
    <p>{`Optionally steal `}<strong parentName="p">{`Pom L`}</strong>{` from Seasoned Thief. If Therion is level 45 or higher, Brigand Leader’s Garb will be 55%, otherwise it’s 15%.`}</p>
    <p>{`Steal/Purchase `}<strong parentName="p">{`Sprightly Necklace (80%)`}</strong>{` from man standing in the center of town.`}<br parentName="p"></br>{`
`}{`If you didn't steal Platinum Sword, buy Trinity or Refined Swrod.`}</p>
    <h4 {...{
      "id": "darius-144-sp"
    }}>{`Darius (144 SP)`}</h4>
    <h5 {...{
      "id": "turn-1-32"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Elemental Break`}</li>
      <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Axe`}</strong>{` x2`}</li>
      <li parentName="ul">{`Therion: Attack x2`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-32"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Alephans`}</li>
      <li parentName="ul">{`Ophilia: Ignis Ardere x3`}</li>
    </ul>
    <p>{`Go to `}<strong parentName="p">{`West S’warkii Trail`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Sidequest: Alphas and the Impresario (talk to Impresario)`}</p>
    <h4 {...{
      "id": "azure-eyed-tiger-33530hp"
    }}>{`Azure-eyed Tiger 33530HP`}</h4>
    <p>{`Ventus Saltare x4`}</p>
    <p>{`Talk to Impresario again to unlock `}<strong parentName="p">{`Ruins of Hornburg`}</strong>{`.`}</p>
    <p>{`TP to `}<strong parentName="p">{`Ruins of Hornburg`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "inventory-2"
      }}>{`Inventory`}</h5>
      <ul>
        <li parentName="ul">{`Sharp M on Tressa if you got one for her.`}</li>
        <li parentName="ul">{`Therion: All Nuts`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-14"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Runelord`}</strong>{`, Balogar’s Blade`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Sorcerer`}</strong>{`, all Sorcerer Skills`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Merchant`}</strong></li>
      </ul>
      <h5 {...{
        "id": "equipment-19"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Battle-tested Axe, Elemental Heavy Armor, -Elemental Augmentor +Mental Belt`}</li>
        <li parentName="ul">{`Therion: -Adamantite Shield, -Empowering Necklace +Mighty Belt (Viper Dagger if not done earlier)`}</li>
        <li parentName="ul">{`Tressa: Optimize, Elemental Augmentor x2`}</li>
        <li parentName="ul">{`Cyrus: Badge of Friendship`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Augmented Elements, Elemental Aid, BP Eater, Surpassing Power`}</li>
      </ul>
    </Menu>
    <p>{`Enter `}<strong parentName="p">{`Gate of Finis`}</strong></p>
    <h3 {...{
      "id": "gate-of-finis"
    }}>{`Gate of Finis`}</h3>
    <h4 {...{
      "id": "miguel-bottom-row-second-from-the-left-170070hp"
    }}>{`Miguel? (Bottom row, second from the left) 170070HP`}</h4>
    <h5 {...{
      "id": "turn-1-33"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Pom S Self`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-33"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Bow`}</strong>{` x3`}</li>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Bow`}</strong>{` x4`}</li>
      <li parentName="ul">{`Ophilia: Balogar’s Blade`}</li>
    </ul>
    <hr></hr>
    <h4 {...{
      "id": "no-balogars-backup"
    }}>{`No Balogars Backup`}</h4>
    <h5 {...{
      "id": "turn-1-34"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Ice Rune`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Tressa: Elemental Break x2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-34"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Bow`}</strong>{` x3`}</li>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Bow`}</strong>{` x4`}</li>
      <li parentName="ul">{`Ophilia: Attack`}</li>
      <li parentName="ul">{`Tressa: Pom M Self`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-15"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Attack`}</li>
      <li parentName="ul">{`Tressa: Ventus x4`}</li>
    </ul>
    <hr></hr>
    <h4 {...{
      "id": "simeon-bottom-row-far-left-176369hp"
    }}>{`Simeon? (Bottom row, far left) 176369HP`}</h4>
    <h5 {...{
      "id": "turn-1-35"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia/Cyrus: Pom S Ophilia/Herb of Clamor on Ophilia or Tressa if silenced`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-35"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Attack x4`}</li>
      <li parentName="ul">{`Ophilia: Balogar’s Blade`}</li>
      <li parentName="ul">{`Tressa: Tradewinds x2`}</li>
    </ul>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-20"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Double Tomahawk`}</li>
        <li parentName="ul">{`Olberic: Platinum Sword, Hasty Helm, Sprightly Necklace x2`}</li>
      </ul>
      <p>{`Replace `}<strong parentName="p">{`Cyrus`}</strong>{` with `}<strong parentName="p">{`Alfyn`}</strong>{`.`}</p>
    </Menu>
    <h4 {...{
      "id": "dragon-bottom-row-far-right-174794hp"
    }}>{`Dragon? (Bottom row, far right) 174794HP`}</h4>
    <h5 {...{
      "id": "turn-1-36"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend / Balogar's if last`}</li>
      <li parentName="ul">{`Alfyn: Axe x2 (4 hits)`}</li>
      <li parentName="ul">{`Therion: Donate BP x2 Ophilia`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-36"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Balogar’s Blade`}</li>
      <li parentName="ul">{`Tressa: Tradewinds x2`}</li>
    </ul>
    <h4 {...{
      "id": "darius-bottom-row-second-from-the-right-188966hp"
    }}>{`Darius? (Bottom row, second from the right) 188966HP`}</h4>
    <h5 {...{
      "id": "turn-1-37"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Can also break with Ophilia Axe + Therion Attack x3`}</em></li>
      <li parentName="ul">{`Ophilia: Pom S Self / Balogars`}</li>
      <li parentName="ul">{`Alfyn: Axe x2 (4 hits)`}</li>
      <li parentName="ul">{`Therion: Shackle Foe / Donate BPx2 Ophilia`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-37"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Balogar’s Blade`}</li>
    </ul>
    <h4 {...{
      "id": "mattias-top-row-far-left-149283hp"
    }}>{`Mattias? (Top row, far left) 149283HP`}</h4>
    <h5 {...{
      "id": "turn-1-38"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend / Balogar's if last`}</li>
      <li parentName="ul">{`Alfyn: Axe x2 (4 hits)`}</li>
      <li parentName="ul">{`Therion: Donate BP x2 Ophilia`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-38"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Balogar’s Blade`}</li>
    </ul>
    <h1 style={{
      color: 'red',
      fontSize: '72px'
    }}>DO THIS MENU BEFORE YVON</h1>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-15"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Dreisang’s Spell`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Warrior`}</strong>{`, All Skills except Divine`}</li>
      </ul>
      <h5 {...{
        "id": "skills-6"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: All Cleric Skills + Divine`}</li>
        <li parentName="ul">{`Alfyn: All Apothecary Skills + Divine`}</li>
        <li parentName="ul">{`Therion: All Thief Skills + Divine`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "yvon-top-row-second-from-the-left-163771hp"
    }}>{`Yvon? (Top row, second from the left) 163771HP`}</h4>
    <h5 {...{
      "id": "turn-1-39"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Dagger x3 Yvon`}</li>
      <li parentName="ul">{`Alfyn/Ophilia: Shadow L / Pom S Ophilia`}</li>
      <li parentName="ul">{`Tressa: Tonitrus Canere`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-39"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Balogar’s Blade Yvon`}</li>
      <li parentName="ul">{`Tressa: Ventus Saltare x3`}</li>
    </ul>
    <h4 {...{
      "id": "venomtooth-tiger-top-row-second-from-the-right-193691hp"
    }}>{`Venomtooth Tiger? (Top row, second from the right) 193691HP`}</h4>
    <h5 {...{
      "id": "turn-1-40"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Pom S Self`}</li>
      <li parentName="ul">{`Alfyn: Injurious Seed + Noxroot`}</li>
      <li parentName="ul">{`Therion: Defend`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-40"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: `}<strong parentName="li">{`Spear`}</strong>{` x4`}</li>
      <li parentName="ul">{`Ophilia: Balogar’s Blade`}</li>
    </ul>
    <h4 {...{
      "id": "werner-top-row-far-right-167865hp"
    }}>{`Werner? (Top row, far right) 167865HP`}</h4>
    <p><em parentName="p">{`Therion needs to be dead at the end of this fight`}</em></p>
    <h5 {...{
      "id": "turn-1-41"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Healing Grape M / Defend`}</li>
      <li parentName="ul">{`Alfyn: Soothing Dust + Curious Bloom`}</li>
      <li parentName="ul">{`Therion: Incite`}</li>
      <li parentName="ul">{`Tressa: Elemental Break x2`}</li>
    </ul>
    <p><em parentName="p">{`Werner will use Sweep and Double Strike on this turn. If he uses Sweep first and Therion dies, Double Strike will kill someone else. Be careful.`}</em></p>
    <h5 {...{
      "id": "turn-2-41"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Healing Grape M / Defend`}</li>
      <li parentName="ul">{`Alfyn: Defend / Axe x3 if Therion dead`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-16"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Axe x3 (6 hits)`}</li>
      <li parentName="ul">{`Ophilia: Balogar’s Blade`}</li>
    </ul>
    <Menu mdxType="Menu">
      <h1 {...{
        "id": "healing-2"
      }}>{`Healing`}</h1>
      <p>{`Revive with Ophilia`}</p>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Primrose > Ophilia`}</li>
        <li parentName="ul">{`Alfyn > Cyrus`}</li>
        <li parentName="ul">{`H'aanit > Tressa`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-16"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Merchant`}</strong>{`, 4 Skills, `}<strong parentName="li">{`Warrior`}</strong>{`, 2 Skills, `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold Trap`}</li>
        <li parentName="ul">{`Cyrus: All Scholar Skills, `}<strong parentName="li">{`Dancer`}</strong>{`, Peacock + Mole`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Starseer`}</strong>{`, 1 Skill, `}<strong parentName="li">{`Warmaster`}</strong>{`, All Skills except Divine`}</li>
        <li parentName="ul">{`H’aanit: Leghold Trap, `}<strong parentName="li">{`Merchant`}</strong>{`, 3 Skills + Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "support-skills-8"
      }}>{`Support Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Hang Tough, Cover`}</li>
        <li parentName="ul">{`H’aanit: Hang Tough`}</li>
        <li parentName="ul">{`Therion: Fortitude, Physical Prowess, BP Eater, Surpassing Power`}</li>
        <li parentName="ul">{`Cyrus: The Show Goes On`}</li>
      </ul>
      <hr></hr>
      <h5 {...{
        "id": "party-1"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Primrose > Tressa`}</li>
        <li parentName="ul">{`Alfyn > H'aanit`}</li>
        <li parentName="ul">{`Therion > Ophilia`}</li>
      </ul>
    </Menu>
    <p>{`Party 1: Tressa, Cyrus, Ophilia, Alfyn`}<br parentName="p"></br>{`
`}{`Party 2: Therion, Olberic, H'aanit, Primrose`}</p>
    <h4 {...{
      "id": "omniscient-eye"
    }}>{`Omniscient Eye`}</h4>
    <h5 {...{
      "id": "turn-1-42"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Defend / Heal if before Add T2`}</li>
      <li parentName="ul">{`Cyrus: Peacock Strut x2 Tressa`}</li>
      <li parentName="ul">{`Ophilia: Heal / Fire Rune`}</li>
      <li parentName="ul">{`Alfyn: Defend / Heal if before Cyrus T2`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-42"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Dohter’s Charity Cyrus`}</li>
      <li parentName="ul">{`Tressa: Lux Congerere x3`}</li>
      <li parentName="ul">{`Ophilia: Heal / Fire Rune / Grape so you don't kill add w/ Fire Rune`}</li>
      <li parentName="ul">{`Cyrus: Revitalizing Jam on everybody`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-17"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`See below for backup if Ophilia is before eye`}</em></li>
      <li parentName="ul">{`Tressa: Dreisang’s Spell Self`}</li>
      <li parentName="ul">{`Cyrus: Alephan's Tressa`}</li>
      <li parentName="ul">{`Ophilia: Attack add (Ice Rune)`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-2"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: Attack x4 (8 hits)`}</li>
      <li parentName="ul">{`Tressa: Elemental Break`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Ophilia: Aelfics Tressa`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-2"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Revitalizing Jam on everybody`}</li>
      <li parentName="ul">{`Tressa: Ventus Saltare x4`}</li>
      <li parentName="ul">{`Ophilia: Balogar’s Blade`}</li>
      <li parentName="ul">{`Alfyn: Nothing / L Stone if missing equipment`}</li>
    </ul>
    <hr></hr>
    <h4 {...{
      "id": "if-turn-3-ophilia-before-eye-tressa-after-eye-tressa-full-sp"
    }}>{`If Turn 3 Ophilia before Eye, Tressa after Eye, Tressa full SP`}</h4>
    <h5 {...{
      "id": "turn-3-18"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: Tradewinds x3`}</li>
      <li parentName="ul">{`Cyrus: Alephan's Tressa`}</li>
      <li parentName="ul">{`Ophilia: Aelfics's Tressa`}</li>
      <li parentName="ul">{`Alfyn: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-3"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Alfyn: 4x Attack (break)`}</li>
      <li parentName="ul">{`Tressa: 4x Ventus`}</li>
      <li parentName="ul">{`Cyrus: Defend`}</li>
      <li parentName="ul">{`Ophilia: 3x Holy Light`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-3"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Revitalizing Jam`}</li>
      <li parentName="ul">{`Ophilia: Balogar’s Blade`}</li>
      <li parentName="ul">{`Tressa: Ventus Saltare x4`}</li>
    </ul>
    <h4 {...{
      "id": "galdera-the-fallen"
    }}>{`Galdera, The Fallen`}</h4>
    <p>{`If Therion 1st Nightmare Chimera x2 Werner's Sword at Maw. Else, first person Pom L Therion & Therion Aebers.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Maw and Lyblac die to 2 Aebers. Blade dies to 1 Aebers + 1 Aebers with either Corrosive or Panther Dance. Try to avoid doing Panther Dance before the first Aebers as a Crit might put Lyblac into red and she can wreck your party.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-0-therion-1st"
    }}>{`Turn 0 (Therion 1st)`}</h5>
    <blockquote>
      <p parentName="blockquote">{`Make sure that Lyblac is after Blade next turn. Else Blade will hit AoE and kill Therion.`}<br parentName="p"></br>{`
`}{`If you get this pattern you'll need 1 Plum on Therion`}</p>
    </blockquote>
    <ul>
      <li parentName="ul">{`Therion: Nighmare Chimera x2 Werner's Sword Abyssal Maw`}</li>
      <li parentName="ul">{`Olberic: Pom L Therion / Armor Corrosive Blade`}</li>
      <li parentName="ul">{`H'aanit / Primrose: Leghold Lyblac/Maw / Pom L / Plum Therion`}</li>
    </ul>
    <h5 {...{
      "id": "turn-1-43"
    }}>{`Turn 1`}</h5>
    <blockquote>
      <p parentName="blockquote">{`Need a Pom L before Therion's turn and another one before his next turn`}<br parentName="p"></br>{`
`}{`Need Corrosive or Panther before Therion's next turn`}</p>
    </blockquote>
    <ul>
      <li parentName="ul">{`Olberic: Pom L Therion / Armor Corrosive Blade`}</li>
      <li parentName="ul">{`Therion: Aebers`}</li>
      <li parentName="ul">{`H'aanit: Pom L Therion / Leghold Trap / Grape M`}</li>
      <li parentName="ul">{`Ophilia: Pom L Therion / Panther Dance Therion / Leghold Trap`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-43"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aebers`}</li>
      <li parentName="ul">{`Rest: Whatever didn't get done T1, Leghold after Galdera's turn if his defenses go down.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-after-defenses-go-down"
    }}>{`Turn after defenses go down`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Nightmare Chimera x3 Death Cleaver`}</li>
      <li parentName="ul">{`Rest: Break with Bow / Spear / Dagger x4`}</li>
    </ul>
    <h5 {...{
      "id": "turn-after-break"
    }}>{`Turn after break`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Aebers / Nightmare Chimera x2 Werner's Sword`}</li>
    </ul>
    <h5 {...{
      "id": "if-galdy-gets-his-turn-after-hunters-and-you-cant-leghold"
    }}>{`If Galdy gets his turn after Hunters and you can't Leghold`}</h5>
    <ul>
      <li parentName="ul">{`Defend so you have someone right before Therion. You need to be able to Red Apple Therion & not have Galdera steal that BP.`}</li>
      <li parentName="ul">{`Therion Nightmare Chimera x3 Death Cleaver, Olberic Corrosive, Hunter Leghold. Next turn Therion Aebers for the kill.`}</li>
    </ul>
    <p>{`Stop time at Spurning Ribbon pop-up`}</p>
    <h2 {...{
      "id": "fin"
    }}>{`FIN`}</h2>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      